import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerRelationDelete.css';
import { DateTimeHelper,CheckFields,SetRequired } from 'utils-lib';
import { ExtendedButton,DateField,ConfirmBox,MessageBox } from 'component-lib';
import { RequestAjaxClass, CustomerModel } from 'models-lib'

var moment = require('moment');
        moment().format();

class CustomerRelationDelete extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.CustomerId = this.props.id;
        this.state.RelationValidUntil = '';
        this.EmployeeNumber = '12345';

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);

        this.CustomerModel = new CustomerModel([this],null, this.Request);

        this.state.Company = "";
    }

    componentDidMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);

        let reqFields = [this.refs.relationValidUntil];

        this.setState({ requiredFields:reqFields },()=>{
              SetRequired.Set(this.state.requiredFields);
        });

        this.CustomerModel.GetCustomersAboveByCustomerId(this.CustomerId,null, false, localStorage.getItem("CustomerAboveId"));
    }

    Update(observer){
        let me = this;
        me.setState({},()=>{
            if(observer === "CustomersAbove"){
                me.setState({Company : this.CustomerModel.CustomersAbove[0].Name});
            }
            else if(observer === "DeleteCustomerRelation"){
                if(this.CustomerModel.DeleteCustomerRelationSuccess === true){
                    Vas.GetView("CustomerRelationDeleteSuccess",{CustomerId : this.CustomerId},true);
                }
            }
        })
    }
    relationDelete(){

        
        /*let cur = DateTimeHelper.StringToDate($("#RelationValidUntil").val(),false,localStorage.getItem('vas_language'));

        alert("Firmenzugehörigkeit des Mitarbeiters mit der MitarbeiterNr. " + this.EmployeeNumber + 
        " wird zum " + DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(cur,true,localStorage.getItem('vas_language'))) + 
        " beendet!!")*/

        this.CustomerModel.DeleteCustomerRelation(this.CustomerId, this.CustomerModel.CustomersAbove[0].Id, this.state.RelationValidUntil);

    }

    checkFields(){
        
        let filled = false;
        if (this.state.requiredFields ){
            
           
            filled = CheckFields.CheckFields(this.state.requiredFields);
            
            if(filled[0] === false){

                ReactDOM.render(<MessageBox 
                Message={Vas.Resources.Labels["NotAllFields"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  ,document.getElementById('messageContainer'));              
            }
            return filled[0]
         }       
    }

    render()
    {     
        return (

          <div style={{ marginTop:10, marginLeft:10 }}>
              <div>

                <div className={"customerRelationDeleteSubTitle"}><b>{Vas.Resources.Labels["DeleteCompanyAssignment"]}</b></div>

                <div id={"DescriptionText"}>
                   {Vas.Resources.Labels["Company"] + ": "}{this.state.Company}
                   
                </div>

                <div className={"customerRelationDeleteContainer"}>

                    <div className={"customerRelationDeleteContainerLarge"}><DateField
                      AppURL={Vas.ApplicationUrl} 
                      MinValue={moment()} 
                      me={this} 
                      Editable={true} 
                      ref={"relationValidUntil"} 
                      IsRequired={true} 
                      Id={"RelationValidUntil"} 
                      Label={Vas.Resources.Labels["CompanyAssignmentUntil"]} 
                      OnBlur={()=>{
                        let cur = DateTimeHelper.StringToDate($("#RelationValidUntil").val(),false,localStorage.getItem('vas_language'));
                        this.setState({RelationValidUntil : moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00")});
                        }}  
                      Language={localStorage.getItem("vas_language")} 
                      FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]} />
                    </div>
                   

                    <div className={"RelationDeleteButtonContainer"}>
                        <ExtendedButton 
                        className={"RelationDeleteButton"} 
                        ref={"RelationDelete"} 
                        Usable={true} 
                        Text={Vas.Resources.Labels["ButtonDeleteCompanyAssignment"]} 
                        OnClick={()=>{ if(this.checkFields()){
                            ReactDOM.render(<ConfirmBox
                            AppURL={Vas.ApplicationUrl}
                            LabelConfirm={Vas.Resources.Labels["Confirm"]}
                            LabelCancel={Vas.Resources.Labels["Cancel"]}
                            modal={true}
                            MessageText={Vas.Resources.Labels["QuestionDeleteCompanyAssignment"]}
                            Click={()=>{this.relationDelete();}} /> , document.getElementById('messageContainer'));}}}
                        Width={240} />
                    </div>

                </div>
              </div>
          </div>
        );
    }
}
export default CustomerRelationDelete;
